import React, { useEffect } from 'react';
import styles from './NextCountdownOverlay.module.scss';
import { PlaylistItem } from 'packages/common/types/playlist';
import { useTranslation } from 'react-i18next';

type Props = {
  nextCountdownTime: number;
  handleCloseOverlay: () => void;
  handleSkipToEnd: () => void;
  nextVideoInTime: number;
  nextItem: PlaylistItem;
};

const NextCountdownOverlay: React.FC<Props> = ({ nextCountdownTime, handleCloseOverlay, handleSkipToEnd, nextVideoInTime, nextItem }: Props) => {
  const { t } = useTranslation(['video']);
  useEffect(() => {
    if (nextItem?.image) {
      const img = new Image();
      img.src = nextItem.image;
    }
  }, [nextItem]);
  return (
    <div className={styles.nextCountdownOverlay}>
      <div className={styles.HeaderSection}>
        <div>
          {t('up_next_countdown', { time: nextCountdownTime })}
        </div>
        <button className={styles.closeButton} onClick={handleCloseOverlay}>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.6006 0.925049C12.7649 0.925049 12.8669 0.973552 12.9473 1.05396C13.0275 1.13426 13.0761 1.23575 13.0762 1.39966C13.0762 1.52307 13.0486 1.61158 13.001 1.68188L12.9473 1.74634L7.69336 7.00024L8.04688 7.35376L12.9473 12.2532C13.0276 12.3335 13.0761 12.4357 13.0762 12.5999C13.0762 12.7641 13.0277 12.8661 12.9473 12.9465C12.8669 13.0269 12.7649 13.0754 12.6006 13.0754C12.4364 13.0754 12.3343 13.0269 12.2539 12.9465L7.35449 8.04614L7.00098 7.69263L1.74707 12.9465C1.66668 13.0269 1.56459 13.0754 1.40039 13.0754C1.23648 13.0754 1.135 13.0268 1.05469 12.9465C0.974285 12.8661 0.925781 12.7641 0.925781 12.5999C0.92581 12.4769 0.952641 12.3888 1 12.3186L1.05469 12.2532L6.30762 7.00024L5.9541 6.64673L1.05469 1.74634C0.974285 1.66594 0.925781 1.56393 0.925781 1.39966C0.925858 1.23562 0.974349 1.13429 1.05469 1.05396C1.13503 0.973617 1.23635 0.925125 1.40039 0.925049C1.52364 0.925049 1.61236 0.951771 1.68262 0.999268L1.74707 1.05396L6.64746 5.95337L7.00098 6.30688L12.2539 1.05396C12.3343 0.973585 12.4364 0.925087 12.6006 0.925049Z"
              fill="#E7E7E3"
              stroke="white"
            />
          </svg>
        </button>
      </div>

      <div className={styles.imageWrapper}>
        <img className={styles.nextCountdownOverlayImage} src={nextItem.image} alt="next video image" />
        <div className={styles.circularButtonContainer} onClick={handleSkipToEnd}>
          <div
            className={styles.progressCircle}
            style={{
              background: `conic-gradient(#ffffff ${((nextVideoInTime - nextCountdownTime) / nextVideoInTime) * 360}deg, rgba(255, 255, 255, 0.2) 0deg)`,
            }}
          >
            <div className={styles.innerCircle}>
              <div className={styles.playIcon}>
                <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2.43292 15.1294C2.01042 15.3858 1.58244 15.4004 1.14895 15.1732C0.716318 14.9468 0.5 14.5969 0.5 14.1236V1.87664C0.5 1.40333 0.716318 1.05307 1.14895 0.825884C1.58244 0.599482 2.01042 0.614471 2.43292 0.870849L12.763 6.99434C13.1432 7.23099 13.3333 7.56626 13.3333 8.00013C13.3333 8.434 13.1432 8.76926 12.763 9.00592L2.43292 15.1294Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.nextCountdownOverlayTitle}>{nextItem.title}</div>
    </div>
  );
};

export default NextCountdownOverlay;
